{
 "note": "made by tools/cars-atlas.mjs from assets/vehicles/cars.atlas; do not edit",
 "image": "/sprites/cars.png",
 "sprites": {
  "dumptruck": {
   "x": 1,
   "y": 131,
   "w": 54,
   "h": 123
  },
  "tow_truck": {
   "x": 1,
   "y": 59,
   "w": 33,
   "h": 70
  },
  "tow_truck2": {
   "x": 57,
   "y": 184,
   "w": 33,
   "h": 70
  },
  "tow_truck3": {
   "x": 92,
   "y": 185,
   "w": 33,
   "h": 69
  },
  "truck2": {
   "x": 127,
   "y": 188,
   "w": 33,
   "h": 66
  },
  "truck3": {
   "x": 162,
   "y": 188,
   "w": 33,
   "h": 66
  },
  "landcruiser": {
   "x": 1,
   "y": 1,
   "w": 29,
   "h": 56
  },
  "landcruiser2": {
   "x": 197,
   "y": 198,
   "w": 29,
   "h": 56
  },
  "landcruiser3": {
   "x": 228,
   "y": 198,
   "w": 29,
   "h": 56
  },
  "van": {
   "x": 259,
   "y": 198,
   "w": 29,
   "h": 56
  },
  "raptor": {
   "x": 290,
   "y": 199,
   "w": 28,
   "h": 55
  },
  "raptor2": {
   "x": 320,
   "y": 199,
   "w": 28,
   "h": 55
  },
  "pickup": {
   "x": 57,
   "y": 131,
   "w": 28,
   "h": 51
  },
  "pickup2": {
   "x": 36,
   "y": 78,
   "w": 28,
   "h": 51
  },
  "pickup3": {
   "x": 350,
   "y": 203,
   "w": 28,
   "h": 51
  },
  "suv": {
   "x": 380,
   "y": 204,
   "w": 28,
   "h": 50
  },
  "suv2": {
   "x": 410,
   "y": 204,
   "w": 28,
   "h": 50
  },
  "van2": {
   "x": 440,
   "y": 204,
   "w": 27,
   "h": 50
  },
  "van3": {
   "x": 469,
   "y": 204,
   "w": 27,
   "h": 50
  },
  "mustang2": {
   "x": 66,
   "y": 80,
   "w": 26,
   "h": 49
  },
  "camaro": {
   "x": 87,
   "y": 134,
   "w": 26,
   "h": 48
  },
  "camaro2": {
   "x": 94,
   "y": 84,
   "w": 26,
   "h": 48
  },
  "challenger2": {
   "x": 115,
   "y": 135,
   "w": 28,
   "h": 48
  },
  "challenger3": {
   "x": 145,
   "y": 138,
   "w": 28,
   "h": 48
  },
  "lexus": {
   "x": 122,
   "y": 85,
   "w": 26,
   "h": 48
  },
  "lexus2": {
   "x": 175,
   "y": 138,
   "w": 26,
   "h": 48
  },
  "gwagon": {
   "x": 150,
   "y": 89,
   "w": 27,
   "h": 47
  },
  "bmw": {
   "x": 179,
   "y": 89,
   "w": 25,
   "h": 47
  },
  "gwagon2": {
   "x": 203,
   "y": 149,
   "w": 27,
   "h": 47
  },
  "patrol": {
   "x": 232,
   "y": 149,
   "w": 27,
   "h": 47
  },
  "patrol2": {
   "x": 261,
   "y": 149,
   "w": 27,
   "h": 47
  },
  "lexus3": {
   "x": 290,
   "y": 149,
   "w": 26,
   "h": 48
  },
  "taxi": {
   "x": 318,
   "y": 149,
   "w": 26,
   "h": 48
  },
  "taxi2": {
   "x": 206,
   "y": 99,
   "w": 26,
   "h": 48
  },
  "lambo": {
   "x": 234,
   "y": 101,
   "w": 27,
   "h": 46
  },
  "lambo2": {
   "x": 263,
   "y": 101,
   "w": 27,
   "h": 46
  },
  "lancer": {
   "x": 292,
   "y": 100,
   "w": 26,
   "h": 47
  },
  "bmw2": {
   "x": 320,
   "y": 100,
   "w": 25,
   "h": 47
  },
  "bmw3": {
   "x": 32,
   "y": 10,
   "w": 25,
   "h": 47
  },
  "lancer2": {
   "x": 346,
   "y": 150,
   "w": 26,
   "h": 47
  },
  "mustang3": {
   "x": 347,
   "y": 101,
   "w": 26,
   "h": 47
  },
  "wrangler": {
   "x": 374,
   "y": 155,
   "w": 24,
   "h": 46
  },
  "sunny": {
   "x": 400,
   "y": 157,
   "w": 25,
   "h": 45
  },
  "wrangler2": {
   "x": 427,
   "y": 156,
   "w": 24,
   "h": 46
  },
  "wrangler3": {
   "x": 453,
   "y": 156,
   "w": 24,
   "h": 46
  },
  "wrangler4": {
   "x": 375,
   "y": 107,
   "w": 24,
   "h": 46
  },
  "tida": {
   "x": 401,
   "y": 112,
   "w": 24,
   "h": 43
  },
  "mini": {
   "x": 427,
   "y": 112,
   "w": 24,
   "h": 42
  },
  "tida2": {
   "x": 453,
   "y": 111,
   "w": 24,
   "h": 43
  },
  "tida3": {
   "x": 479,
   "y": 159,
   "w": 24,
   "h": 43
  },
  "convertible": {
   "x": 479,
   "y": 116,
   "w": 24,
   "h": 41
  },
  "figo": {
   "x": 206,
   "y": 56,
   "w": 24,
   "h": 41
  },
  "figo2": {
   "x": 232,
   "y": 56,
   "w": 24,
   "h": 41
  },
  "porsche": {
   "x": 258,
   "y": 58,
   "w": 24,
   "h": 41
  },
  "bike2": {
   "x": 284,
   "y": 63,
   "w": 16,
   "h": 35
  },
  "bike": {
   "x": 302,
   "y": 65,
   "w": 16,
   "h": 33
  }
 }
}
